import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import { ResourcesService } from '../../../services/resources.service';
import { DatePipe } from '@angular/common';
import { isEmpty } from 'rxjs';
import { ModalComponent } from '../../shared/modal/modal.component';
import * as BlobUtil from 'blob-util';
import { SowService } from '../../../services/sow.service';

@Component({
  selector: 'app-sow',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule
],
  templateUrl: './sow.component.html',
  styleUrls: ['./sow.component.scss'],
    providers: [
      DatePipe
    ]
})
export class SowComponent implements OnInit {

  resource: any = {};
  listResourceSow: any = [];
  listPoNumber: any = [];
  listAdo: any = [];
  listChapter: any = [
    { value: 'Java Development', text: 'Java Development' },
    { value: 'Salesforce Development', text: 'Salesforce Development' },
    { value: 'Mulesoft Development', text: 'Mulesoft Development' },
    { value: 'Quality Assurance', text: 'Quality Assurance' },
    { value: 'Project Management', text: 'Project Management' }
  ];

  listPrimaryTask: any = [
    {value: 'Development', text: 'Development'},
    {value: 'Design', text: 'Design'},
    {value: 'Quality Assurance', text: 'Quality Assurance'},
    {value: 'Project Management', text: 'Project Management'},
    {value: 'Support', text: 'Support'}
  ]

  listType : any = [
    {value: 'CAPEX', text: 'CAPEX'},
    {value: 'OPEX', text: 'OPEX'}
  ]

  listCapexCode : any = [
    {value : '08.29', text: 'BSS - FABRICA DE SOFTWARE BSS	08.29'},
    {value : '08.26', text: 'INFRA IT - OTROS INFRAESTRUCTURA IT	08.26'},
    {value : '08.42', text: 'BI Y ANAYLTICS - OTROS BI Y ANALYTICS	08.42'},
    {value : '08.38', text: 'ERP - FABRICA DE SOFTWARE ERP	08.38'},
    {value : '08.47', text: 'OTROS IT - OTROS FABRICA DE SOFTWARE	08.47'},
    {value : '08.14', text: 'OTROS IT - SEGURIDAD Y CONTROL	08.14'}
  ]

  listTeam: any = [];
  listVendor: any = [];
  listContract: any = [];
  upload: any = {};

  constructor(
    private __ref: DynamicDialogRef,
    private __sowService : SowService,
    private __datePipe: DatePipe,
    private __config: DynamicDialogConfig,
    private __dialogService : DialogService,
  ) {

  }

  ngOnInit(): void {
    this.getListResourceSow();
    if (!this.isEmpty(this.__config.data.item)) {
      this.resource = this.__config.data.item;
      this.resource.ID_SOW = this.resource.SOWID;
      this.getListpoNumber();
    } else {
      this.resource.ID_SOW = 0;
    }
  }

  isEmpty(obj: any): boolean {
    return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length === 0;
  }

  getListResourceSow() {
    //this.__spinner.show({ type: 'loader' });
    this.listResourceSow = [];
    this.__sowService.getListResourceSow().subscribe((resp: any) => {
      this.listResourceSow = resp.listResources;
      //.__spinner.close();
    });
  }

  selectItem(event: any) {
    console.log(event);
    let item = this.listResourceSow.find((e: any) => e.RESOURCE_ID == event);
    this.resource.RESOURCE_ID = item.RESOURCE_ID;
  }

  getListpoNumber() {
    //this.__spinner.show({ type: 'loader' });
    this.listPoNumber = [];
    this.__sowService.getListpoNumber(this.resource.PONUMBER).subscribe((resp: any) => {
      this.listPoNumber = resp.listPoNumber;
      //this.__spinner.close();
    });
  }

  saveSow() {
    //this.__spinner.show({ type: 'loader' });
    console.log(this.resource);
    if (this.resource.RESOURCE_ID == undefined || this.resource.PONUMBER == undefined ||
      this.resource.PO_LINE_ID == undefined || this.resource.START_DATE == undefined || this.resource.END_DATE == undefined) {
        this.onShowMessage();
      return;
    }
    if (this.resource.RESOURCE_ID?.length == 0 || this.resource.PONUMBER?.length == 0 ||
      this.resource.PO_LINE_ID?.length == 0 || this.resource.START_DATE?.length == 0 || this.resource.END_DATE?.length == 0) {
        this.onShowMessage();
      return;
    }
    this.__sowService.saveSow(this.resource).subscribe((resp: any) => {
      if(+resp?.an_resultado==0) {
        //this.__spinner.close();
        this.accept();
      }
    });
  }

  /**
   *
   * @param event
   * @returns
   */
  handleFileInput(event : any) {
    this.upload.fileName = event.target.files[0].name;
    this.upload.fileType = event.target.files[0].type;
    BlobUtil.blobToBase64String(event.target.files[0]).then((res) => {
      this.upload.fileUpload = res;
      this.resource.SOWDOC = this.upload.fileUpload;
      this.resource.FILENAME = this.upload.fileName;
    });
  }

  onShowMessage() {
    let confirm = this.__dialogService.open(ModalComponent, {
      width: '30%',
      header: 'Complete fields required',
      dismissableMask: false,
      closable: false,
    });

    confirm?.onClose.subscribe((resp: any) => {
    });
  }

  cancel() {
    let data = {
      accion: 'cancel'
    }
    this.__ref.close(data);
  }

  accept() {
    let data = {
      accion: 'success'
    }
    this.__ref.close(data);
  }

}
